// 文章7数据信息
export default {
  id: 'dayunshan_107',
  content: `# 荞麦有4000年种植历史，荞麦叶究竟有何独特价值
  ![荞麦有4000年种植历史，荞麦叶究竟有何独特价值1](https://cdn.keihong.tech/img/20250518213751999.jpg)

![荞麦有4000年种植历史，荞麦叶究竟有何独特价值2](https://cdn.keihong.tech/img/20250518213755281.jpg)

![荞麦有4000年种植历史，荞麦叶究竟有何独特价值3](https://cdn.keihong.tech/img/20250518213758415.jpg)

![荞麦有4000年种植历史，荞麦叶究竟有何独特价值4](https://cdn.keihong.tech/img/20250518213801651.jpg)

![荞麦有4000年种植历史，荞麦叶究竟有何独特价值5](https://cdn.keihong.tech/img/20250518213804651.jpg)

![荞麦有4000年种植历史，荞麦叶究竟有何独特价值6](https://cdn.keihong.tech/img/20250518213807640.jpg)

![荞麦有4000年种植历史，荞麦叶究竟有何独特价值7](https://cdn.keihong.tech/img/20250518213810714.jpg)`
}
